/**
     * @desc 查询已上架NFT作品
用于查询一个已上架的NFT作品详细信息，包含挂单信息和最高报价信息
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/item/getOnSaleItem', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/item/getOnSaleItem', params);
}
